//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'sexlink',
  props: ['resource', 'index', 'minimal', 'ratio', 'type', 'thumb'],
  components: {
    Description: () => import('~/components/DescriptionResources.vue'),
  }
}
